import {POService} from "../resource";
import swal from "sweetalert2";
import i18n from "./i18n";

const POModule = {
	namespaced: true, 
	state: { 
		isLoading:false,
		datas: [],
	},
	mutations: { 
		SET_DATA(state, data) {
			state.datas = data;
		}
	},
	actions: {
		createData({ commit, state }, params) {
			return POService.POCreate(params);
		},

		updateData({ commit, state }, params) {
			return POService.POUpdate(params.id,params.payload);
		},

		deleteData({ commit, state }, params) {
			return POService.PODelete(params);
		},

		async listData({ commit, state }, params) {
			state.isLoading = true
			swal.fire({
				title: i18n.t(`processing`),
				type: "info",
				allowEscapeKey: false,
				allowOutsideClick: false,
				onOpen: () => {
					swal.showLoading();
				}
			  });
			try
			{
				const response = await POService.POList(params);
				commit("SET_DATA", response.data.Data == null ? [] : response.data.Data);
				swal.close()
				state.isLoading = false
			}
			catch (error)
			{
				commit("SET_DATA", []);
				swal.close()
				state.isLoading = false
			}
		},

		getDetail({ commit, state }, params) {
			return POService.PODetail(params);
		},
		duplicate({ commit, state }, params) {
			return POService.PODuplicate(params);
		},
		getFile({ commit, state }, params) {
			return POService.POGetFile(params);
		},
		approve({ commit, state }, params) {
			return POService.POApprove(params);
		},
		cancel({ commit, state }, params) {
			return POService.POCanncel(params);
		},
		partialclose({ commit, state }, params) {
			return POService.POPartialClose(params);
		},
		close({ commit, state }, params) {
			return POService.PODelete(params);
		},
	},
	getters: {
		getData(state) {
			return state.datas;
		},
	},
};

export default POModule;